import apiAxios from "helpers/apiAxios";

// Purchase Requisition / Purchase Order — cấu hình người ký cố định theo SITE
// (Financial Controller, GM). Dùng chung cho cả PR và PO.
const BASE = "/erp/purchase_signer_settings";

export const getPurchaseSignerSettings = () => apiAxios.get(BASE).then((r) => r.data);
export const updatePurchaseSignerSettings = (settings) => apiAxios.put(BASE, { settings }).then((r) => r.data);
export const searchPurchaseSignerUsers = (q) => apiAxios.get(`${BASE}/users`, { params: { q } }).then((r) => r.data);
export const getPurchaseSignerSites = () => apiAxios.get(`${BASE}/sites`).then((r) => r.data);

// Purchase Order — "PO access": Department / User nào được xem TẤT CẢ Purchase Order
// (ngoài chủ phiếu / người ký bước hiện tại, vốn tự có quyền xem phiếu liên quan tới mình).
const PO_ACCESS_BASE = "/erp/purchase_order_view_grants";

export const getPurchaseOrderViewGrants = () => apiAxios.get(PO_ACCESS_BASE).then((r) => r.data);
export const updatePurchaseOrderViewGrants = (departmentIds, userIds) =>
  apiAxios.put(PO_ACCESS_BASE, { department_ids: departmentIds, user_ids: userIds }).then((r) => r.data);
export const searchPurchaseOrderViewDepartments = (q, siteId) => apiAxios.get(`${PO_ACCESS_BASE}/departments`, { params: { q, site_id: siteId } }).then((r) => r.data);
export const searchPurchaseOrderViewUsers = (q) => apiAxios.get(`${PO_ACCESS_BASE}/users`, { params: { q } }).then((r) => r.data);
export const getPurchaseOrderViewSites = () => apiAxios.get(`${PO_ACCESS_BASE}/sites`).then((r) => r.data);
